import { render, staticRenderFns } from "./RmsEquipDetail.vue?vue&type=template&id=6b0bcb3d&scoped=true&"
import script from "./RmsEquipDetail.vue?vue&type=script&lang=js&"
export * from "./RmsEquipDetail.vue?vue&type=script&lang=js&"
import style0 from "./RmsEquipDetail.vue?vue&type=style&index=0&id=6b0bcb3d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0bcb3d",
  null
  
)

component.options.__file = "RmsEquipDetail.vue"
export default component.exports